import styled from "styled-components";

const RightPartImage = styled.img`
  max-width: 100%;
  height: auto;
  border: 15px solid #fff;

  @media (max-width: 1599px) {
    border: 10px solid #fff;
  }
`;
export default RightPartImage;
